export enum MaxIdTypeEnum {
  FontManipulation = 'fontManipulation',
  ImageManipulation = 'imageManipulation',
  PositionalAnomaly = 'positionalAnomaly',
  SemanticAnomaly = 'semanticAnomaly'
}

export type MaxIds = {
  fontManipulation: number;
  imageManipulation: number;
  positionalAnomaly: number;
  semanticAnomaly: number;
};

export enum MaxIdsEnum {
  updateMaxIds = 'UPDATE_MAX_IDS'
}

export type UpdateMaxIdsAction = {
  type: MaxIdsEnum.updateMaxIds;
  payload: {
    type: MaxIdTypeEnum;
    value: number;
  };
};
